/* eslint-disable @typescript-eslint/typedef */
/**
 * @desc Query parameter constants for document-related API endpoints.
 * These must match the backend query tokens exactly.
 *
 * @see Backend: src/_common/constants/query_tokens.constants.ts
 * @see {@link EthicalHackingDocumentService}
 */
export const DocumentQueryParams = {
  /** Document owner ID parameter */
  DOCUMENTABLE_ID: 'documentable_id',

  /** Flag indicating if document is linked to a finding/vulnerability */
  IS_FINDING_LINKED: 'is_finding_linked'
} as const;
